// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#app button{cursor:pointer}.container{height:100%;width:100%;display:flex;justify-content:center}.centerEmoji,.leftEmoji,.rightEmoji{width:auto}.emojiBtn{background-color:transparent;border:none}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
